import axios from 'axios';

import { getFullTextSearchString } from '../../InvoicingClientService';
import ClosureDTO from '../types/ClosureDTO';
import { ClosureFiltersDTO } from '../types/ClosureFiltersDTO';

const url = '/invoicingservice/api/contractplacements';

export const createContractPlacement = (closureDTO: ClosureDTO) =>
  axios.post(`${url}/create`, closureDTO);

export const getContractPlacements = (closureFiltersDTO: ClosureFiltersDTO) =>
  axios.post(`${url}/list`, closureFiltersDTO);

export const getContractPlacementById = (id: string) => axios.get(`${url}/${id}`);

export const searchContractPlacements = (
  clientId: string,
  ourEntityId: string,
  searchTerm: string
) =>
  axios.get(
    `${url}/candidate-name?clientId=${clientId}&ourEntityId=${ourEntityId}&searchTerm=${encodeURIComponent(
      getFullTextSearchString(searchTerm)
    )}`
  );
